function padLeft(number: number) {
  return number.toString(10).padStart(2, '0')
}

function formatDateForDisplay(dateString: string): string {
  const date: Date = new Date(dateString)
  const day: string = padLeft(date.getDate())
  const month: string = padLeft(date.getMonth() + 1)

  return `${day}.${month}.${date.getFullYear()}`
}

function formatDateForServer(dateString: string): string {
  const date: Date = new Date(dateString)
  const day: string = padLeft(date.getDate())
  const month: string = padLeft(date.getMonth() + 1)

  return `${date.getFullYear()}-${month}-${day}`
}

export { formatDateForDisplay, formatDateForServer }
